import { useState, useEffect } from "react";
import axios from "axios";
import "./ManageEmployee.css";

const EmployeeManagement = () => {
  const [employees, setEmployees] = useState([]);
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const response = await axios.get(
        "https://api.swasthmitra.com/api/employee/getEmployees"
      );
      setEmployees(response.data);
    } catch (error) {
      console.error("Error fetching employees", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `https://api.swasthmitra.com/api/employee/deleteEmployee/${id}`
      );
      setMessage("Employee deleted successfully");
      fetchEmployees();
    } catch (error) {
      setMessage("Failed to delete employee");
    }
  };

  const handleEdit = (employee) => {
    setEditingEmployee(employee);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `https://api.swasthmitra.com/api/employee/updateEmployee/${editingEmployee._id}`,
        editingEmployee
      );
      setMessage("Employee updated successfully");
      setEditingEmployee(null);
      fetchEmployees();
    } catch (error) {
      setMessage("Failed to update employee");
    }
  };

  return (
    <div className="employee-management-container">
      <h2>Employee Management</h2>
      {message && <p className="message">{message}</p>}
      <table>
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Email</th>
            <th>Mobile Number</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {employees.map((emp) => (
            <tr key={emp._id}>
              <td>{emp.fullName}</td>
              <td>{emp.email}</td>
              <td>{emp.mobileNumber}</td>
              <td>
                <button onClick={() => handleEdit(emp)}>Edit</button>
                <button onClick={() => handleDelete(emp._id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {editingEmployee && (
        <div className="modal">
          <div className="modal-content">
            <h3>Edit Employee</h3>
            <form onSubmit={handleUpdate}>
              <input
                type="text"
                name="fullName"
                value={editingEmployee.fullName}
                onChange={(e) =>
                  setEditingEmployee({
                    ...editingEmployee,
                    fullName: e.target.value,
                  })
                }
                required
              />
              <input
                type="email"
                name="email"
                value={editingEmployee.email}
                onChange={(e) =>
                  setEditingEmployee({
                    ...editingEmployee,
                    email: e.target.value,
                  })
                }
                required
              />
              <input
                type="text"
                name="mobileNumber"
                value={editingEmployee.mobileNumber}
                onChange={(e) =>
                  setEditingEmployee({
                    ...editingEmployee,
                    mobileNumber: e.target.value,
                  })
                }
                required
              />
              <button type="submit">Update</button>
              <button onClick={() => setEditingEmployee(null)}>Cancel</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeeManagement;
